export const tramitesLista = [
    {
        'tramitesLista_nombre' : 'Autorización de Fraccionamiento',
        'tramitesLista_descripcion' : 'Es el documento en el que se autoriza la división de un predio en dos o más lotes, y que requiera del trazo de vialidades, así como la ejecución de obras de urbanización que le permitan la dotación de infraestructura, equipamiento y servicios urbanos.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/602',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Autorización de Fusión',
        'tramitesLista_descripcion' : 'Trámite por medio del cual se autoriza la unión de dos o más predios colindantes para formar una sola entidad global.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/590',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Autorización de Protocolización',
        'tramitesLista_descripcion' : 'Es el documento mediante el cual se da el visto bueno de la Secretaría de Obras Públicas y Ordenamiento Territorial, a las autorizaciones de subdivisión, relotificación, fusión y fraccionamiento, otorgadas por los municipios; para realizar la inscripción de las mismos en el Registro Público de la Propiedad y del Comercio, siempre y cuando no contravenga las disposiciones jurídicas y lineamientos en la materia.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/620',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Autorización de Relotificación de Fraccionamiento',
        'tramitesLista_descripcion' : 'Es el documento en el que se autoriza la modificación de lotes, áreas urbanas y/o vialidades de un fraccionamiento o área urbana.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/617',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Autorización de Subdivisión',
        'tramitesLista_descripcion' : 'Es el documento en el que se autoriza la partición de un predio en dos o más fracciones y que no requieran el trazo de vías públicas.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/592',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Autorización de Venta de Lotes',
        'tramitesLista_descripcion' : 'Corresponde a una constancia en la que se especificará haber cumplido con los requerimientos de urbanización y satisfecho el otorgamiento de garantías de las obras de urbanización del fraccionamiento.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/621',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Autorización para el Uso y Aprovechamiento del Derecho de Vía Estatal',
        'tramitesLista_descripcion' : 'Autorización para el Uso y Aprovechamiento de todas las Vías de Comunicación Terrestre y Aéreas Comprendidas Dentro de la Red Carretera Estatal.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1776',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Autorización de Régimen de Propiedad en Condominio',
        'tramitesLista_descripcion' : 'Es el documento en el que se autoriza la partición o división de un predio en áreas privativas y áreas comunes.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/622',
        'icon' : 'icon-authorization'
    },
    {
        'tramitesLista_nombre' : 'Constancia de Uso de Suelo',
        'tramitesLista_descripcion' : 'Es el documento en el cual se hacen constar los usos generales de un predio en base a su uso actual o al uso que establezcan los Programas de Desarrollo Urbano y Ordenamiento Ecológico, el cual no autoriza modificación, construcción o alteración del predio.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/540',
        'icon' : 'icon-constancy'
    },
    {
        'tramitesLista_nombre' : 'Constancias de Verificación de la Poligonal de Fraccionamiento',
        'tramitesLista_descripcion' : 'Es el acto administrativo expedido por la Secretaría por el que se hace constar la verificación de la poligonal de un fraccionamiento',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1623',
        'icon' : 'icon-constancy'
    },
    {
        'tramitesLista_nombre' : 'Constancia de Viabilidad',
        'tramitesLista_descripcion' : 'Es el acto administrativo expedido por la Secretaría por el que se hace constar la aptitud de un determinado predio para el desarrollo de una acción urbana.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1439',
        'icon' : 'icon-constancy'
    },
    {
        'tramitesLista_nombre' : 'Constancia de no invasión a fraccionamiento',
        'tramitesLista_descripcion' : 'Es el acto administrativo expedido por la Secretaría, mediante el cual se hace constar que un predio, no invade un fraccionamiento, área verde u otro.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1622',
        'icon' : 'icon-constancy'
    },
    {
        'tramitesLista_nombre' : 'Constancia no comprendida',
        'tramitesLista_descripcion' : 'Es el acto administrativo expedido por la Secretaría por el que se hace constar la aptitud de un determinado predio para el desarrollo de una acción urbana.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1621',
        'icon' : 'icon-constancy'
    },
    {
        'tramitesLista_nombre' : 'Dictamen de Estudio de Impacto Urbano y Vial',
        'tramitesLista_descripcion' : 'Documento expedido por la Secretaría, mediante el cual se establecen las acciones compensatorias y mitigatorias del impacto de una acción urbana.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/639',
        'icon' : 'icon-expert_opinion'
    },
    {
        'tramitesLista_nombre' : 'Derecho de Preferencia',
        'tramitesLista_descripcion' : 'Es el documento en donde se determina la posible adquisición de los predios comprendidos en las zonas de reserva o en suelo urbanizable, señalados en los Planes o Programas de Desarrollo Urbano y Ordenamiento Territorial, cuando dichos predios vayan a ser objeto de enajenación.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/637',
        'icon' : 'icon-right-of-preference'
    },
    {
        'tramitesLista_nombre' : 'Expedición de Oficio de Afectación de Vialidades y Señalamiento por Accidentes',
        'tramitesLista_descripcion' : 'Oficios de Conformidad para la Reparación de los Daños de Vialidades y Señalamiento por Accidentes en Todas las Vías de Comunicación Terrestre Dentro de la Red Carretera Estatal.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1778',
        'icon' : 'icon-issuance'
    },
    {
        'tramitesLista_nombre' : 'Expedición de Oficio de Afectación o no Afectación del Derecho de Vía',
        'tramitesLista_descripcion' : 'Oficio de Afectación o no Afectación del Derecho de Via en todas las Vías de Comunicación Terrestre que estén dentro de la Red Carretera Estatal',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1777',
        'icon' : 'icon-issuance'
    },
    {
        'tramitesLista_nombre' : 'Pago de bases Licitaciones Públicas Estatales',
        'tramitesLista_descripcion' : 'Este trámite es solamente para personas físicas o morales interesadas en participar en los procedimientos de Licitaciones Públicas Estatales, que cumplan con los requisitos establecidos en las bases de dichos procedimientos, los cuales están obligados a pagar el costo de las mismas de acuerdo a la normatividad, por lo que se genera la referencia o el recibo de pago, que le da derecho a su participación en las licitaciones públicas convocadas por esta Secretaría.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1608',
        'icon' : 'icon-base-payment'
    },
    {
        'tramitesLista_nombre' : 'Licencia de Uso de Suelo',
        'tramitesLista_descripcion' : 'Es el documento en el cual se autoriza los usos y destinos específicos de un predio en base a lo que establezcan los programas de desarrollo urbano y a las compatibilidades de usos colindantes, la cual no autoriza su modificación, construcción, alteración o fraccionamiento.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/553',
        'icon' : 'icon-land-use'
    },
    {
        'tramitesLista_nombre' : 'Prórroga de trámite: Modalidad Autorización de Fraccionamiento y Modalidad Licencia de Uso de Suelo',
        'tramitesLista_descripcion' : 'Se constituye para dar vigencia a la acción urbana en referencia, cuando esta no ha cumplido con las obligaciones establecidas en la autorización correspondiente',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1609',
        'icon' : 'icon-extension'
    },
    // {
    //     'tramitesLista_nombre' : 'Prórroga de Licencia de Uso de Suelo',
    //     'tramitesLista_descripcion' : 'Se constituye para dar vigencia a cualquier licencia cuando esta ha cumplido los requerimientos y obligaciones establecidas en la licencia de uso de suelo.',
    //     'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/1610'
    // },
    // {
    //     'tramitesLista_nombre' : 'Refrendo de Director Responsable y Corresponsable',
    //     'tramitesLista_descripcion' : 'Actualizar la vigencia del Registro de Director Responsable y Corresponsable y categorías autorizadas.',
    //     'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/737'
    // },
    {
        'tramitesLista_nombre' : 'Director Responsable y Corresponsable: Modalidad Registro y Modalidad Refrendo',
        'tramitesLista_descripcion' : 'Obtener el registro o refrendo, estableciendo su categoría de acuerdo a su experiencia y profesión, para tramitar como aval las licencias, constancias y demás autorizaciones establecidas en las disposiciones reglamentarias, teniendo bajo su encargo la realización de los proyectos',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/740',
        'icon' : 'icon-dryc'
    },
    {
        'tramitesLista_nombre' : 'Copias certificadas y simples',
        'tramitesLista_descripcion' : 'Otorgar certeza jurídica al ciudadano de los documentos que obran dentro de los archivos de esta Secretaría.',
        'tramitesLista_link' : 'http://ruts.hidalgo.gob.mx/ver/642',
        'icon' : 'icon-certified-copies'
    },
]